// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"f2fc6170","513":"b52b619d","703":"e21dd5fc","787":"28499dda"}[chunkId] + ".chunk.js";
};